module.exports = __webpack_public_path__ + "img/antoine.c411a00a.jpg";